/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterBooleanType extends models.ParameterBase {
    constructor() {
        super();
        this.setDiscriminator("ParameterBooleanType");
    }

    getFixupPrototypeFunction() { return ParameterBooleanType.fixupPrototype; }

    static newInstance(model: Partial<ParameterBooleanType>): ParameterBooleanType {
        let obj = Object.assign(new ParameterBooleanType(), model);
        ParameterBooleanType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterBooleanType>): ParameterBooleanType {
        if (!model) return null;
        return ParameterBooleanType.newInstance(<ParameterBooleanType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterBooleanType) {
        if (!obj) return;

        models.ParameterBooleanType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterBooleanType): boolean {
        if (models.ParameterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ParameterBooleanType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
